import { render, staticRenderFns } from "./RecoveryAuth.vue?vue&type=template&id=1e7db90c&scoped=true&"
import script from "./RecoveryAuth.vue?vue&type=script&lang=js&"
export * from "./RecoveryAuth.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryAuth.vue?vue&type=style&index=0&id=1e7db90c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7db90c",
  null
  
)

export default component.exports